export enum SwiadczeniobiorcyFilter {
  AKTYWNY_RODZIC = 'AR',
  SWIADCZENIE_WYCHOWAWCZE = 'SW',
  SWIADCZENIE_RODZINNE = 'SR',
  DOBRY_START = 'DS',
  KARTA_DUZEJ_RODZINY = 'KDR',
  FUNDUSZ_ALIMENTACYJNY = 'FA',
  POMOC_SPOLECZNA = 'PS',
  SWIADCZENIA_WSPIERAJACE = 'PPW',
}

export const SWIADCZENIOBIORCY_FILTER_LABELS: Record<
  SwiadczeniobiorcyFilter,
  string
> = {
  [SwiadczeniobiorcyFilter.AKTYWNY_RODZIC]: 'Aktywny Rodzic',
  [SwiadczeniobiorcyFilter.SWIADCZENIE_WYCHOWAWCZE]: 'Świadczenie Wychowawcze',
  [SwiadczeniobiorcyFilter.SWIADCZENIE_RODZINNE]: 'Świadczenie Rodzinne',
  [SwiadczeniobiorcyFilter.DOBRY_START]: 'Dobry Start',
  [SwiadczeniobiorcyFilter.KARTA_DUZEJ_RODZINY]: 'Karta Dużej Rodziny',
  [SwiadczeniobiorcyFilter.FUNDUSZ_ALIMENTACYJNY]: 'Fundusz Alimentacyjny',
  [SwiadczeniobiorcyFilter.POMOC_SPOLECZNA]: 'Pomoc Społeczna',
  [SwiadczeniobiorcyFilter.SWIADCZENIA_WSPIERAJACE]: 'Świadczenia Wspierające',
};

export function getSwiadczeniobiorcyFilterDropdownItems() {
  return Object.entries(SWIADCZENIOBIORCY_FILTER_LABELS).map(
    ([key, label]) => ({
      label,
      value: key as SwiadczeniobiorcyFilter,
    }),
  );
}
